<app-toast />
<app-spinner />

@if (headerService.isVisible()) {
  <app-header />
}

<main class="app-main">
  <router-outlet />
</main>
